import React, { useEffect, useState } from 'react';
import { useI18n } from '../i18n';

export default function NavigationFeedback() {
  const [feedback, setFeedback] = useState({ message: '', id: 0 });
  const { t } = useI18n();

  useEffect(() => {
    let timeoutId;

    const handleFeedback = (event) => {
      setFeedback({
        message: event.detail?.message || t('nav.alreadyHere'),
        id: Date.now(),
      });
      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(() => {
        setFeedback((current) => ({ ...current, message: '' }));
      }, 1300);
    };

    window.addEventListener('navigation-feedback', handleFeedback);

    return () => {
      window.clearTimeout(timeoutId);
      window.removeEventListener('navigation-feedback', handleFeedback);
    };
  }, [t]);

  return (
    <div
      className={`navigation-feedback${feedback.message ? ' is-visible' : ''}`}
      key={feedback.id}
      role="status"
      aria-live="polite"
    >
      {feedback.message}
    </div>
  );
}
